import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateAuthState from './auth';
import updateUsersState from './user';
import updateRolesState from './role';

const handlers = {
  ...updateAuthState,
  ...updateUsersState,
  ...updateRolesState,
};

export default (state = initialState, action) => chooseReducer(state, action, handlers);
